





























import { Component, Vue } from 'vue-property-decorator';
import VxBreadcrumb from '@/layouts/components/VxBreadcrumb.vue';
import BookingComponent from '@/components/common/BookingComponent.vue';
import router from '@/router';
import AuthModule from '@/store/AuthModule';
import { postCreditRequest } from '@/api/api';
import DataRequestComponent from '@/components/prescriber/DataRequestComponent.vue';
@Component({
    components: {
        DataRequestComponent
    },
})
export default class ProductAndServices extends Vue {
    redirect(href: string) {
        window.open(href, '_blank');
    }

    services = [
        {
            title: "SwissLife",
            logo: "swisslife.png",
            partner_site: 'https://identification.swisslife.fr/cas/login?service=https://swissline.swisslife.fr/account/connect',
            public_site: 'https://www.swisslife.fr/home.html'
        },
        {
            title: "AGEAS",
            logo: "ageas.png",
            partner_site: 'https://www.ageas-patrimoine.fr/',
            public_site: 'https://www.ageas.fr'
        },
        {
            title: "GENERALI",
            logo: "generali.png",
            partner_site: 'https://www.nomineo.net/',
            public_site: 'https://generali-patrimoine.fr/'
        },
        {
            title: "VIEPLUS",
            logo: "vieplus.png",
            partner_site: 'https://www.previ-direct.com/web/partenaires//espace-partenaires-vieplus',
            public_site: 'https://www.vieplus.fr/'
        },
        {
            title: "ERES",
            logo: "eres.png",
            partner_site: 'https://extranet.eres-group.com/user/login',
            public_site: 'https://www.eres-group.com/'
        },
        {
            title: "UPSIDEO",
            logo: "upsideo.png",
            partner_site: 'https://juliette-identity.upsideo.fr/Account/Login?ReturnUrl=%2Fconnect%2Fauthorize%2Fcallback%3Fclient_id%3Dcgp_react_upsideo_user%26redirect_uri%3Dhttps%253A%252F%252Fconseiller.upsideo.fr%252Fcallback%26response_type%3Dcode%26scope%3Dopenid%2520profile%2520webapi.scope%2520app.scope%26state%3D1579703996ed40c7a007a90a4371e0d2%26code_challenge%3DDEFuCdoIsZ17FBi47GuYncT72c0fDS09lu_KFBcZqiQ%26code_challenge_method%3DS256%26acr_values%3Dtenant%253Auser%26response_mode%3Dquery',
            public_site: 'https://www.upsideo.fr/'
        },
        {
            title: "UAF Life",
            logo: "uaf-life.png",
            partner_site: 'https://securite.uaflife-patrimoine.fr/life-securite/login.xhtml',
            public_site: 'https://www.uaflife-patrimoine.fr/'
        },

    ]

}
